import { render, staticRenderFns } from "./PriceCard.vue?vue&type=template&id=7e06e33a&scoped=true&"
import script from "./PriceCard.vue?vue&type=script&lang=js&"
export * from "./PriceCard.vue?vue&type=script&lang=js&"
import style0 from "./PriceCard.vue?vue&type=style&index=0&id=7e06e33a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e06e33a",
  null
  
)

export default component.exports